import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Container, Grid, Typography, Button, Stack } from '@material-ui/core';
import TeamsTable from '../components/admin/team/TeamsTable';
import Page from '../components/Page';
import TeamDetailsModal from '../components/admin/team/TeamDetailsModal';
import AddTeamDialog from '../components/admin/team/AddTeamDialog';
import useVrackApi from '../hooks/useVrackApi';
import { useIsFeatureFlagEnabled } from '../utils/FeatureFlags';

export default function Teams() {
  const [teamList, setTeamList] = useState([]);

  const [teamDetailsModal, setTeamDetailsModalOpen] = useState(false);
  const [addTeamModal, setAddTeamModalOpen] = useState(false);
  const [modalTeam, setModalTeam] = useState('');
  const currentUserEmail = useSelector((state) => state.userDetails?.value?.email) ?? '';
  const isVrackAdminEnabled = useIsFeatureFlagEnabled('vrack_admin');

  // Initialize useVrackApi hooks for both the admin and per-user team list endpoints
  const adminFetchTeamsApi = useVrackApi('GET', '/admin/teams');
  const userFetchTeamsApi = useVrackApi('GET', `/users/${currentUserEmail}/teams`);

  useEffect(() => {
    updateTeams();
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [isVrackAdminEnabled, currentUserEmail]);

  const updateTeams = async () => {
    if (!isVrackAdminEnabled && currentUserEmail === '') {
      return null;
    }
    const fetchData = isVrackAdminEnabled
      ? adminFetchTeamsApi.fetchData
      : userFetchTeamsApi.fetchData;
    try {
      const data = await fetchData();
      setTeamList(data);
      return data;
    } catch (error) {
      console.error('failed to get list of teams ', error.message);
      return null;
    }
  };

  return (
    <Page title="Admin | Teams | Virtual Racks">
      <TeamDetailsModal
        team={modalTeam}
        isOpen={teamDetailsModal}
        closeHandler={() => {
          setTeamDetailsModalOpen(false);
        }}
      />
      <AddTeamDialog
        isOpen={addTeamModal}
        updateTeams={updateTeams}
        closeHandler={() => {
          setAddTeamModalOpen(false);
        }}
      />
      <Container maxWidth={false}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Stack direction="row" justifyContent="space-between">
              <Typography variant="h4">Teams</Typography>
              {isVrackAdminEnabled && (
                <Button
                  onClick={() => {
                    setAddTeamModalOpen(true);
                  }}
                  variant="contained"
                >
                  New Team
                </Button>
              )}
            </Stack>
          </Grid>
          <Grid item xs={12}>
            <TeamsTable
              updateTeams={updateTeams}
              openModal={setTeamDetailsModalOpen}
              setModalTeam={setModalTeam}
              teamsList={teamList}
            />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}
